import React from 'react';

export function getAbbreviatedHash(transactionHash, firstNumberOfDigits, lastNumberOfDigits, excludeHex) {
  if (!transactionHash) return <span>&mdash;</span>;
  let firstDigit = (excludeHex) ? 2 : 0;
  firstNumberOfDigits = (excludeHex) ? firstNumberOfDigits : firstNumberOfDigits + 2;
  return <span>{transactionHash.slice(firstDigit, firstNumberOfDigits)}...{transactionHash.slice(transactionHash.length-lastNumberOfDigits, transactionHash.length)}</span>;
}
